import React from "react"
import * as styles from "./SupplierSignupForm.module.scss"

const FormContact = ({ data, handleChange }) => (
  <section>
    <div className={styles.firstInput}>
      <label htmlFor="name">Company Name*</label>
      <p>This will be your publicly displayed company name</p>
      <input required id="name" name="name" onChange={handleChange} value={data.name} />
    </div>
    <br />
    {/* <div className={styles.refference}>
          <label htmlFor="name">Reference (optional)</label>
          <p>Reference an existing supplier</p>
          <input
            id="reference"
            name="reference"
            value={data.reference}
            onChange={handleChange}
          />
        </div> */}

    <h3>Contact information</h3>
    <p>Please provide your Company’s preferred contact details</p>
    <div>
      <label htmlFor="contactname">Name</label>
      <p>(Optional) The person to handle all HOPP enquiries</p>
      <input id="contactname" name="contactname" onChange={handleChange} value={data.contactname} />
    </div>
    <div>
      <label htmlFor="email">Email*</label>
      <p>All enquiries will be sent to this email address</p>

      <input
        required
        type="email"
        id="email"
        name="email"
        onChange={handleChange}
        value={data.email}
      />
    </div>
    <div className={styles.twoColumn}>
      <div>
        <label htmlFor="phone">Phone*</label>
        <p>The best number for enquiries</p>

        <input
          required
          type="tel"
          id="phone"
          name="phone"
          onChange={handleChange}
          value={data.phone}
        />
      </div>
      <div>
        <label htmlFor="website">Website</label>
        <p>Your company website</p>

        <input
          id="website"
          name="website"
          onChange={handleChange}
          value={data.website}
          placeholder="https://example.com"
        />
      </div>
    </div>
  </section>
)

export default FormContact
